import React from "react";

import Background from "../../../assets/market/market-bg-01.png";
import Image from "../../../assets/market/market-01-choice-b.png";

import GamePageLayout from "../GamePageLayout";

const MarketPage4 = ({ setCurrentPage }) => {
  return (
    <GamePageLayout
      bg={Background}
      img={Image}
      onClickNext={() => setCurrentPage("market-5")}
    >
      주말인데 나가기 귀찮아~
      <br />
      *마트에서 주문하니
      <br />
      20분 만에 오네?
      <br />
      너무 편하다.
    </GamePageLayout>
  );
};

export default MarketPage4;
